import React from "react";
import greenTick from "../../../../assets/images/generic/teenyicons_tick-circle-outline-green.svg";
import { isValidRegex } from "@frameworks/web/utils/validation";
import { PasswordValidationObject } from "./constant";
export const passwordmsg = " Special characters not allowed are: ( ) < > ? , % - + : ; [ ] { } | ~ ‘ ^ _ “ / $";
const PasswordValidation = (props) => {
    const [password, setPassword] = React.useState(PasswordValidationObject);
    const updateState = () => {
        if (password.length > 0) {
            let Temp = [...password];
            password.map((ele, idx) => {
                if (!isValidRegex(props.password, ele.regex))
                    Temp[idx].value = true;
                else
                    Temp[idx].value = false;
            });
            setPassword(Temp);
        }
    };
    React.useEffect(() => {
        updateState();
        let validationFail = password.find((ele) => ele.value === false);
        if (validationFail) {
            props.setIsValidated(false);
        }
        else
            props.setIsValidated(true);
    }, [props.password]);
    const validationCheck = (validationCheck) => {
        return validationCheck ? (React.createElement("img", { src: greenTick })) : (React.createElement("i", { className: "edel-icon-rounded-close" }));
    };
    const ValidationObjects = () => {
        return password.map((ele) => {
            return (React.createElement("div", null,
                React.createElement("span", null, validationCheck(ele.value)),
                React.createElement("span", { className: `labelcontain ${ele.value ? "green" : ""}` }, ele.name),
                ele.isOverLay && ele.isOverLay));
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "passwordContainer" }, ValidationObjects())));
};
export default PasswordValidation;
